import React from 'react';
import { ICampaignRewards } from '../../../types/campaign.types';
import RewardCard from '../../reward/card';

const AvailableRewards: React.FC<{
  availableRewards: ICampaignRewards['rewards'];
  merchantName?: string;
}> = ({ availableRewards, merchantName }) => {
  return (
    <>
      <p className="mb-2 text-start text-base font-semibold">
        Available rewards
      </p>

      {availableRewards.length === 0 ? (
        <p className="text-gray-500">No rewards available for this campaign.</p>
      ) : (
        <div className="flex flex-col gap-y-4">
          {availableRewards.map((reward) => (
            <RewardCard
              key={reward.id}
              merchantName={merchantName}
              {...reward}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default AvailableRewards;
